import { render, staticRenderFns } from "./AdminPageEditor.vue?vue&type=template&id=18ccfbe5&"
import script from "./AdminPageEditor.vue?vue&type=script&lang=js&"
export * from "./AdminPageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports